import { render, staticRenderFns } from "./ModalForgeConsole.vue?vue&type=template&id=03b4193c&"
import script from "./ModalForgeConsole.vue?vue&type=script&lang=js&"
export * from "./ModalForgeConsole.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgeConsole.vue?vue&type=style&index=0&id=03b4193c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports